import React from 'react';
import ChangeFlightsButton from './ChangeFlightsButton';

import FlightSession from './FlightSession';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import config from '../../../config';

const ReservationTimeExpiredModal = ({ children }) =>
  FlightSession.hasExpired() ? (
    <Modal isOpen={true}>
      <ModalHeader>Reservation Time Expired</ModalHeader>
      <ModalBody>
        Sorry! Your reservation time for the flights has expired. Please try
        booking again.
        If there is any issue, please reach us directly via WhatsApp at <br/> 
        <a href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`} style={{ color: '#00C0FF' }} rel="noopener noreferrer" target="_blank">{config.honeyguidePhoneNumber}</a>,
        <a href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`} style={{ color: '#00C0FF' }} rel="noopener noreferrer" target="_blank">{config.honeyguidePhoneNumber}</a> or Email us at {' '}
        <a href={`mailto:${config.honeyguideEmail}`} style={{ color: '#00C0FF' }}>{config.honeyguideEmail}</a>
        <div className="text-center mt-3">
          <ChangeFlightsButton />
        </div>
      </ModalBody>
    </Modal>
  ) : (
    children
  );

export default ReservationTimeExpiredModal;



// WEBPACK FOOTER //
// ./src/screens/Flights/Common/ReservationTimeExpiredModal.js